export default "__VITE_ASSET__Kw8jwkEk__"